import { lazy } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loadable from "../layout/fullLayout/loadable/loadable";
import { OOPSError } from "../views/authentication/OopsError";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoute";
import { customerRoutes } from "../views/customers/customer.router";
import { leadRoutes } from "../views/leads/Leads.router";
import { opportunityRoutes } from "../views/opportunites/opportunity.router";
import { sourceRoutes } from "../views/Source/source.router";
import { profileRoutes } from "../views/Profile/profile.router";
import { securityRoutes } from "../views/Security/security.router";
import { templateRoutes } from "../views/EmailTemplates/EmailTemplate.router";
import { printTemplatesRoutes } from "../views/PrintTemplates/PrintTemplates.router";
import { dashboardRoutes } from "../views/dashboard/dashboard.router";
import { envConfigRoutes } from "../views/EnvConfig/EnvConfig.router";
import { Chat } from "../views/Chat";
import { componyInformationRoutes } from "../views/CompanyInformation/CompanyInformation.router";
import { inventoryRoutes } from "../views/Inventory/router";
import { categoryRoutes } from "../views/category/category.router";
import { bookingRoutes } from "../views/bookingList/booking.router";
import { categoryTypeRoutes } from "../views/categoryType/categoryType.router";
import { foodMenuRoutes } from "../views/Food/food.router";
import { ReviewReplyRoutes } from "../views/ReviewReply/ReviewReply.router";
import { reviewQuestionnaireRoutes } from "../views/ReviewQuestionnaire/ReviewQuestionnaire.router";
import { marketCampaign } from "../views/WhatsAppTemplate/whatsappTemplate.router";
import { zoneRoutes } from "../views/userZone/userZone.router";
import { whatsAppQRRoutes } from "../views/whatsAppQR/whatsAppQR.router";
import { orgEnvConfigRoutes } from "../views/orgEnvConfig/orgEnvConfig.router";
import { CompanyOutletRoutes } from "../views/companyOutlet/companyOutlet.router";
import { paymentDetailsRoutes } from "../views/paymentDetails/paymentDetails.router";
import { OtherUserLogin } from "../views/authentication/OtherUserLogin";
import { SubscriptionRoutes } from "../views/subscription/subscription.router";
import { ChooseSubscription } from "../views/chooseSubscription/chooseSubscription";
import { automationListRoutes } from "../views/Automation/Automation.router";
import { StatusRoutes } from "../views/status/status.router";
import { CustomCancelationReasonRoutes } from "../views/customCancelationReason/CustomCancelationReason.route";
import { enrCancelationReasonRoutes } from "../views/enrCancelationReason/enrCancelationReason.route";
import { chatbotRoutes } from "../views/Chatbot/chatbot.router";
import { marketCampaignV2Routes } from "../views/market-campaign/MarketCampaign.router";
import { LandingPage } from "../views/authentication/SignUp/LandingPage";
import { UserSignUp } from "../views/authentication/SignUp/UserSignUp";
import { supportRoutes } from "../views/support/support.router";
import { masterFormsRoutes } from "../views/MasterForms/masterForms.router";
import { serviceRoutes } from "../views/service/service.router";
import { eventsRoutes } from "../views/events/events.router";
import { dynamicFormsRoutesV2 } from "../views/DynamicFormsV2/dynamicForms.router";
import { upsellRoutes } from "../views/upselling/upselling.router";
import { genAiRoutes } from "../views/GenAI/genAi.router";
import { chatLeadRoutes } from "../views/chatLeads/chatLeads.router";
import { ChooseSubscriptionRoutes } from "../views/chooseSubscription/chooseSubscription.router";
import { quickReplyTemplateRoutes } from "../views/QuickReplyTemplate/quickReplyTemplate.router";
import { masterQuickReplyTemplateRoutes } from "../views/MasterQuickReplyTemplate/masterQuickReplyTemplate.router";
import { CompanyNotAssign } from "../views/authentication/CompanyNotAssign";
import { RestrictedWordsRoutes } from "../views/restrictedWords/restrictedWords.router";
import { totalBookingRoutes } from "../views/totalBookings/totalbooking.router";
import { generalLeadRoutes } from "../views/GeneralLeads/generalLeads.router";
import { addonRoutes } from "../views/Addon/addon.router";
import { notificationRoutes } from "../views/Notifications/notification.router";

import { appViewsRoutes } from "../views";
import { ActionItemCategoryRoutes } from "../views/ActionItemCategory/ActionItemCategory.router";
import { ActionItemDynamicFormRoutes } from "../views/ActionItemDynamicForm/ActionItemDynamicForm.router";
import { IntentsRoutes } from "../views/Intents/Intents.router";
import { ReportRoutes } from "../views/Reports/report.router";
import { MessageSequenceRoutes } from "../views/MessageSequence/MessageSequence.router";
import { moduleSettingRoutes } from "../views/ModuleSettings/moduleSetting.router";
import { roomTypeRoutes } from "../views/roomType/roomType.router";
import { AgentToolsRoutes } from "../views/AgentTools/AgentTools.router";
import { CatalogsRoutes } from "../views/Catalogs/Catalogs.router";
import { DebugRoutes } from "../views/Debug/Debug.router";

import { SubscriptionPlanSelector } from "../views/chooseSubscription/SubscriptionPlanSelector";
import { PublicSubscriptionPurchase } from "../views/chooseSubscription/PublicSubscriptionPurchase";
import { deliveryLogDetailsRoutes } from "../views/DeliveryLogDetails/DeliveryLogDetails.router";
import { SubscriptionSetup } from "../views/chooseSubscription/SubscirptionSetup";
import { TalkvitUserSignUp } from "../views/authentication/SignUp/TalkvitUserSignUp";
import { APP_VARIANT } from "../constants";
import { config } from "../config";
import { REACT_APP_NAV_ROUTES } from "./AppNavigation";
import { userOnboardRoutes } from "../views/authentication/SignUp/userOnboard.router";
import { BusinessOnboardRoutes } from "../views/authentication/business-onboard/BusinessOnboard.router";
import { BusinessOnboard } from "../views/authentication/business-onboard/BusinessOnboard";
import { BusinessOnboardLanding } from "../views/authentication/business-onboard/BusinessOnboardLanding";

/* ***Layouts**** */
/**
 * Lazy loads the FullLayout component.
 *
 * This approach is used to split the code and load the FullLayout component only when it is needed.
 * It helps in reducing the initial load time of the application by deferring the loading of the FullLayout component
 * until it is actually required. This can improve the performance and user experience of the application.
 *
 * The `Loadable` function is used to handle the loading state and potential errors during the loading process.
 * The `lazy` function from React is used to dynamically import the FullLayout component.
 */

const FullLayout = Loadable(
  lazy(() =>
    import("../layout/fullLayout/FullLayout").then(({ FullLayout }) => ({
      default: FullLayout,
    })),
  ),
);
const BlankLayout = Loadable(
  lazy(() => import("../layout/blankLayout/BlankLayout")),
);
/* ***End Layouts**** */

const Error = Loadable(
  lazy(() =>
    import("../views/authentication/Error").then(({ Error }) => ({
      default: Error,
    })),
  ),
);

/* ****Pages***** */

const Login = Loadable(
  lazy(() =>
    import("../views/authentication/Login").then(({ Login }) => ({
      default: Login,
    })),
  ),
);
const AccessDenied = Loadable(
  lazy(() =>
    import("../views/authentication/AccessDenied").then(({ AccessDenied }) => ({
      default: AccessDenied,
    })),
  ),
);

const SubscriptionError = Loadable(
  lazy(() =>
    import("../views/authentication/SubscriptionError").then(
      ({ SubscriptionError }) => ({
        default: SubscriptionError,
      }),
    ),
  ),
);

const PublicManageLead = Loadable(
  lazy(() =>
    import("../views/PublicLead/publicManageLead").then(
      ({ PublicManageLead }) => ({
        default: PublicManageLead,
      }),
    ),
  ),
);

const PublicReviewRating = Loadable(
  lazy(() =>
    import("../views/PublicReview/PublicReviewRating").then(
      ({ PublicReviewRating }) => ({
        default: PublicReviewRating,
      }),
    ),
  ),
);

const ForgotPassword = Loadable(
  lazy(() =>
    import("../views/authentication/ForgotPassword").then(
      ({ ForgotPassword }) => ({
        default: ForgotPassword,
      }),
    ),
  ),
);

function LegacyPublicReviewRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/public/review", search }} replace />;
}

export const Router = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <FullLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        exact: true,
        element: <Navigate to="/dashboard" replace />,
      },

      // ------------- opportunites ----------------------------

      { path: "access", element: <AccessDenied /> },
      { path: "error", element: <OOPSError /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
      {
        path: "subscription-billing",
        element: <SubscriptionError />,
      },
    ]
      .concat(dashboardRoutes)
      .concat(leadRoutes)
      .concat(generalLeadRoutes)
      .concat(chatbotRoutes)
      .concat(customerRoutes)
      .concat(opportunityRoutes)
      .concat(sourceRoutes)
      .concat(profileRoutes)
      .concat(securityRoutes)
      .concat(templateRoutes)
      .concat(printTemplatesRoutes)
      .concat(envConfigRoutes)
      .concat(componyInformationRoutes)
      .concat(inventoryRoutes)
      .concat(categoryRoutes)
      .concat(bookingRoutes)
      .concat(supportRoutes)
      .concat(masterFormsRoutes)
      .concat(dynamicFormsRoutesV2)
      .concat(serviceRoutes)
      .concat(eventsRoutes)
      .concat(categoryTypeRoutes)
      .concat(foodMenuRoutes)
      .concat(ReviewReplyRoutes)
      .concat(reviewQuestionnaireRoutes)
      .concat(marketCampaign)
      .concat(zoneRoutes)
      .concat(whatsAppQRRoutes)
      .concat(CompanyOutletRoutes)
      .concat(paymentDetailsRoutes)
      .concat(SubscriptionRoutes)
      .concat(orgEnvConfigRoutes)
      .concat(automationListRoutes)
      .concat(StatusRoutes)
      .concat(CustomCancelationReasonRoutes)
      .concat(enrCancelationReasonRoutes)
      .concat(marketCampaignV2Routes)
      .concat(genAiRoutes)
      .concat(upsellRoutes)
      .concat(chatLeadRoutes)
      .concat(ChooseSubscriptionRoutes)
      .concat(quickReplyTemplateRoutes)
      .concat(masterQuickReplyTemplateRoutes)
      .concat(RestrictedWordsRoutes)
      .concat(totalBookingRoutes)
      .concat(ReportRoutes)
      .concat(addonRoutes)
      .concat(appViewsRoutes)
      .concat(ActionItemCategoryRoutes)
      .concat(ActionItemDynamicFormRoutes)
      .concat(IntentsRoutes)
      .concat(MessageSequenceRoutes)
      .concat(moduleSettingRoutes)
      .concat(userOnboardRoutes)
      .concat(roomTypeRoutes)
      .concat(AgentToolsRoutes)
      .concat(CatalogsRoutes)
      .concat(DebugRoutes)
      .concat(MessageSequenceRoutes)
      .concat(deliveryLogDetailsRoutes)
      .concat(notificationRoutes),
  },


  // --------------------------------TASK ROUTING----------------------------------------------

  {
    path: "/auth",
    element: (
      <PublicRoute>
        <BlankLayout />
      </PublicRoute>
    ),
    children: [
      { path: "404", element: <Error /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <ForgotPassword /> },
      {
        path: "signup",
        element:
          config.app.variant === APP_VARIANT.BANQUET_FIRST ? (
            <BusinessOnboardLanding />
          ) : (
            <LandingPage />
          ),
      },
      {
        path: "signup/setup-company",
        element:
          config.app.variant === APP_VARIANT.BANQUET_FIRST ? (
            <BusinessOnboard />
          ) : config.app.variant === APP_VARIANT.TALKVIT ? (
            <TalkvitUserSignUp />
          ) : (
            <UserSignUp />
          ),
      },

      ...BusinessOnboardRoutes,

      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/other",
    element: <BlankLayout />,
    children: [
      { path: "user-access", element: <OtherUserLogin /> },
      { path: "404", element: <Error /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <ForgotPassword /> },

      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },

  {
    path: "/choose-subscription",
    element: <ChooseSubscription />,
  },
  {
    path: "/signup-choose-subscription-billing",
    element: <SubscriptionPlanSelector />,
  },
  {
    path: REACT_APP_NAV_ROUTES.subscription.pricing,
    element: <SubscriptionPlanSelector />,
  },
  // {
  //   path: REACT_APP_NAV_ROUTES.subscription.error,
  //   element: <SubscriptionError />,
  // },
  {
    path: REACT_APP_NAV_ROUTES.subscription.choose,
    element: <SubscriptionPlanSelector />,
  },
  {
    path: "/company-not-assigned",
    element: <CompanyNotAssign />,
  },
  {
    path: "/student-lead-form",
    element: <PublicManageLead />,
  },
  {
    path: "/public-review",
    element: <LegacyPublicReviewRedirect />,
  },
  {
    path: "/public/review",
    element: <PublicReviewRating />,
  },
  {
    path: "/public/subscribe",
    element: <PublicSubscriptionPurchase />,
  },
  { path: "/chat", element: <Chat /> },
];
